import { render, staticRenderFns } from "./BToggle.vue?vue&type=template&id=1cc10548&"
import script from "./BToggle.vue?vue&type=script&lang=js&"
export * from "./BToggle.vue?vue&type=script&lang=js&"
import style0 from "./BToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports